import React, { useState, useRef, useEffect } from "react";
import filterIcon from "../../assets/images/icons/filter-sm.png";

const FilterDropdown = ({ filterOptions, onFilterChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState("All");
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  const handleFilterChange = (filter) => {
    setSelectedFilter(filter);
    onFilterChange(filter);
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="dropdown" ref={dropdownRef}>
      <button
        className="btn outline dropdown-toggle"
        type="button"
        onClick={toggleDropdown}
        aria-expanded={isOpen}
      >
        <img src={filterIcon} alt="Filter" /> Add Filters
      </button>
      {isOpen && (
        <ul className="dropdown-menu check show">
          {filterOptions.map((filter, index) => (
            <li key={index}>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id={`flexCheckDefault${index}`}
                  checked={selectedFilter === filter}
                  onChange={() => handleFilterChange(filter)}
                />
                <label
                  className="form-check-label"
                  htmlFor={`flexCheckDefault${index}`}
                >
                  {filter}
                </label>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default FilterDropdown;
